  import React, { useEffect, useState } from 'react'
  import compose from 'recompose/compose'
  import { withI18n } from '../../hocs'
  import * as S from './styled'
  import ActionDialog from '../action-dialog'
  import { CustomAlert } from '../../atoms'
  import InputField from '../../atoms/input-field'
  import { useAppContext } from '../../../context/appContext'
  import { ALERT_LEVEL } from '../../../config/constants'

  const ModalConfirmLogin = ({ open, handleClose, i18n, auth, isDisabledButton, onSubmit, onVerificationSuccess, setIsPasswordValidated }) => {
    const { createAlert } = useAppContext()

    const [showAlert, setShowAlert] = useState(false)
    const [alert, setAlert] = useState({ message: '', severity: '' });
    const [password, setPassword] = useState('');


    useEffect(() => {
      if (alert.message) {
        setShowAlert(true);
        const timer = setTimeout(() => {
          setShowAlert(false);
          setAlert({ message: '', severity: '' });
        }, 3000);
        return () => clearTimeout(timer);
      }
    }, [alert]);

    const handleModalClose = () => {
      handleClose();    
    };

    const handleVerifiedPassword = async (e) => {
      e && e.preventDefault();

      try {
        await onSubmit({ email: auth.email, password });
        // Validar la contraseña es lo que cierra el modal (lo escucha el modal de la integración);
        // el aviso sale fuera, que este ya no está
        setIsPasswordValidated(prevValue => {
          onVerificationSuccess(!prevValue);
          return !prevValue;
        });
        createAlert(i18n.keywords_rpa.successPasswordVerified, ALERT_LEVEL.SUCCESS);
      } catch (error) {
        setAlert({ message: i18n.keywords_rpa.errorPasswordIncorrect, severity: 'error' });
        setShowAlert(true);
        console.error('Error al validar contraseña:', error);    
      }
    };

    return (
      <ActionDialog
        open={open}
        title={i18n.keywords_rpa.verifyPasswordUserPlatformToEditeIntegration}
        onClose={handleModalClose}
        onConfirm={handleVerifiedPassword}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={i18n.keywords_rpa.verifyButton}
        confirmDisabled={isDisabledButton}
        disableBackdropClose
      >
        {/* Sin submit: Intro no debe recargar la página; se verifica con el botón */}
        <S.Form autoComplete="off" onSubmit={e => e.preventDefault()}>
          <input autoComplete="false" name="hidden" type="text" style={{'display': 'none'}}></input>
          <div>
            <S.Label>{i18n.keywords_rpa.emailLabel}</S.Label>
            <InputField
              name='email'
              placeholder={auth.email}
              value={auth.email}
              type='text'
              autoComplete="false"
              disabled
            />
          </div>
          <div>
            <S.Label>{i18n.keywords_rpa.passwordLabel}</S.Label>
            <InputField
              name='password'
              placeholder={i18n.keywords_rpa.placeholderPassword}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type='password'
              autoComplete="false"
            />
          </div>
          {showAlert && <CustomAlert severity={alert.severity} message={alert.message} />}
        </S.Form>
      </ActionDialog>
    )
  }

  const enharce = compose(withI18n)

  export default enharce(ModalConfirmLogin)